import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import { DataReqUpdate, ITrongMuon } from '@/services/TrongMuon/index';

export async function getTrongMuon(payload: { page: number; limit: number; cond?: any }) {
  const { page, limit, cond } = payload;
  return axios.get(`${ip3}/trong-muon-ngoai-gio/pageable`, {
    params: {
      page,
      limit,
      cond,
    },
  });
}
export async function getGiaoVien(payload: {
  donViId: string;
  page: number;
  limit: number;
  cond?: any;
}) {
  const { page, limit, cond, donViId } = payload;
  return axios.get(`${ip3}/ho-so-giao-vien/pageable`, {
    params: {
      donViId,
      page,
      limit,
    },
  });
}

export async function getAllGiaoVien(payload: {
  donViId: string;
  cond?: any;
}) {
  const { cond, donViId } = payload;
  return axios.get(`${ip3}/ho-so-giao-vien/pageable/v2`, {
    params: {
      donViId,
    },
  });
}
export async function getLop(payload: {
  donViId: string;
  page: number;
  limit: number;
  cond?: any;
}) {
  const { page, limit, cond, donViId } = payload;
  return axios.get(`${ip3}/don-vi/pageable/${donViId}/child`, {
    params: {
      page,
      limit,
    },
  });
}

export async function getAllLop(payload: {
  donViId: string;
  cond?: any;
}) {
  const {  cond, donViId } = payload;
  return axios.get(`${ip3}/don-vi/pageable/${donViId}/child/v2`, {
    params: {
      loaiDonVi: "Lop"
    }
  });
}

export async function createTrongMuon(payload: ITrongMuon.DataReq) {
  return axios.post(`${ip3}/trong-muon-ngoai-gio/hieu-truong`, payload);
}
export async function updateTrongMuon(id: string, data: ITrongMuon.DataReqUpdate) {
  return axios.put(`${ip3}/trong-muon-ngoai-gio/${id}`, data);
}

export async function confirmTrongMuon(id: string, trangThai: string) {
  return axios.put(`${ip3}/trong-muon-ngoai-gio/${id}/xac-nhan`, { trangThai: trangThai });
}

export async function checkTrongMuon(payload: { giaoVienId: string; thang: number; nam: number }) {
  const { giaoVienId, thang, nam } = payload;
  return axios.get(`${ip3}/trong-muon-ngoai-gio/all`, {
    params: {
     cond:{
       giaoVienId: giaoVienId,
       thang: thang,
       nam: nam,
     }
    },
  });
}
